import React from 'react';
import './FAQ.css';

const FAQ = () => {
  return (
    <div className="faq-container">
      <h1>Frequently Asked Questions</h1>
      <ul className="faq-list">
        <li>
          <strong>What services do you offer?</strong>
          <p>We provide freelance software engineering support, technical interview prep, 1:1 coaching, and a variety of software engineering courses.</p>
        </li>
        <li>
          <strong>How do I book a session?</strong>
          <p>You can book a session by visiting our <a href="/counseling?type=coaching" className="faq-link">Coaching page</a> or <a href="/counseling?type=freelance" className="faq-link">Freelance Support page</a>.</p>
        </li>
        <li>
          <strong>Can I get help with my freelance projects?</strong>
          <p>Yes! We offer project guidance, code review, and real-world tech help for freelancers and businesses.</p>
        </li>
        <li>
          <strong>What topics are covered in your courses?</strong>
          <p>Our courses cover data structures, algorithms, OOP, clean coding, frontend and backend development, and more.</p>
        </li>
        <li>
          <strong>How do I contact support?</strong>
          <p>For urgent issues, use our <a href="/contact" className="faq-link">Contact page</a> or email <a href="mailto:support@cleancodeeng.com" className="faq-link">support@cleancodeeng.com</a>.</p>
        </li>
      </ul>
    </div>
  );
};

export default FAQ;
